import React, { createContext, useState } from "react";
import { MeetingProvider, Constants } from "@videosdk.live/react-sdk";
import { ILSContainer } from "../src/interactive-live-streaming/components/ILSContainer.js";
import { BrowserRouter as Router } from 'react-router-dom';
import { MeetingAppProvider } from "./MeetingAppContextDef";
import { ErrorBoundary } from "./components/ErrorBoundary";


export const ModeContext = createContext()



const App = () => {
  const url = window.location;
  const urlParams = new URLSearchParams(url.search);

  const meetingId = urlParams.get("meetingId");
  const token = urlParams.get("token");
  const participantId = urlParams.get("participantId");
  const [isMeetingStarted, setMeetingStarted] = useState(false);
  const [ModeOfEntry, setModeOfEntry] = useState(false);


  return (
    <Router>
      <ModeContext.Provider value={{ ModeOfEntry, setModeOfEntry }}>

        {meetingId && token && (
          <MeetingAppProvider
          >
            <MeetingProvider
              config={{
                meetingId: meetingId, // required
                name: "recorder", // required
                micEnabled: false,
                webcamEnabled: false,
                participantId: participantId,
                mode: Constants.modes.CONFERENCE,
              }}
              token={token}
              reinitialiseMeetingOnConfigChange={true}
              joinWithoutUserInteraction={true}
            >
              <ErrorBoundary>
                <ILSContainer
                  onMeetingLeave={() => {
                    setMeetingStarted(false);
                  }}
                  meetingMode={Constants.modes.CONFERENCE}
                />
              </ErrorBoundary>
            </MeetingProvider>
          </MeetingAppProvider>
        )

        }

      </ModeContext.Provider>

    </Router>
  );
};

export default App;
